import { render } from "./DefaultDoughnutChart.vue?vue&type=template&id=d1082a8c"
import script from "./DefaultDoughnutChart.vue?vue&type=script&lang=js"
export * from "./DefaultDoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__